{
  "name": "@ns/onboarding-payment",
  "version": "1.0.0",
  "description": "nodeStream onboarding subscription payments",
  "inputs": {},
  "outcomes": {
    "complete": {}
  }
}
